import { RootState } from "../Store";

export const selectOperations = (state: RootState) => state.operation.operations;
